/* eslint-disable react/jsx-props-no-spreading */

const RowingJules = props => {
  return (
    <svg
      viewBox="0 0 463 324"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M93.9139 267.676C92.4011 262.03 95.7516 256.227 101.397 254.714L217.252 223.671C222.897 222.158 228.701 225.509 230.213 231.154L234.778 248.192C236.795 255.719 232.328 263.457 224.801 265.474L129.391 291.039C114.336 295.073 98.861 286.138 94.8269 271.083L93.9139 267.676Z"
        fill="#4F46E5"
      />
      <path
        d="M58.3043 134.781C54.2702 119.726 63.2047 104.251 78.2599 100.217V100.217L122.085 263.777L94.8256 271.081L58.3043 134.781Z"
        fill="#4F46E5"
      />
      <path
        d="M210.191 210.953L223.821 207.301L231.126 234.561C233.143 242.088 228.675 249.826 221.148 251.843V251.843L210.191 210.953Z"
        fill="#4338CA"
      />
      <path
        d="M190.949 84.6319C188.932 77.1043 181.195 72.6371 173.667 74.6541L78.2578 100.219C70.7302 102.236 66.263 109.973 68.28 117.501L108.453 267.43L162.973 252.822C166.737 251.813 168.971 247.945 167.962 244.181V244.181C166.954 240.417 169.187 236.548 172.951 235.54L213.841 224.583C221.368 222.566 225.836 214.829 223.819 207.301L190.949 84.6319Z"
        fill="#6366F1"
      />
      <path
        d="M153.03 121.124C153.414 116.994 158.728 115.57 161.125 118.955L162.48 120.868C163.233 121.932 164.414 122.614 165.713 122.735L168.047 122.952C172.177 123.335 173.601 128.649 170.216 131.046L168.303 132.401C167.239 133.155 166.557 134.336 166.436 135.634L166.22 137.969C165.836 142.098 160.522 143.522 158.125 140.138L156.77 138.224C156.016 137.16 154.835 136.478 153.537 136.358L151.202 136.141C147.073 135.758 145.649 130.443 149.033 128.046L150.947 126.691C152.011 125.938 152.693 124.757 152.813 123.458L153.03 121.124Z"
        fill="#312E81"
      />
      <path
        d="M133.075 155.691C133.459 151.561 138.773 150.137 141.17 153.522L148.872 164.397C149.625 165.462 150.806 166.143 152.105 166.264L165.374 167.496C169.504 167.88 170.928 173.194 167.543 175.591L156.668 183.293C155.604 184.047 154.922 185.228 154.801 186.526L153.569 199.796C153.185 203.925 147.871 205.349 145.474 201.965L137.772 191.089C137.018 190.025 135.837 189.343 134.539 189.223L121.27 187.99C117.14 187.607 115.716 182.292 119.101 179.895L129.976 172.193C131.04 171.44 131.722 170.259 131.843 168.96L133.075 155.691Z"
        fill="#312E81"
      />
      <path
        d="M108.457 267.433C106.44 259.905 110.907 252.168 118.435 250.151L213.844 224.586L221.148 251.846L125.739 277.41C118.211 279.427 110.474 274.96 108.457 267.433V267.433Z"
        fill="#EEF2FF"
      />
      <path
        d="M293.508 133.783C308.649 147.41 362.402 149.682 373.758 89.1152"
        stroke="#6366F1"
        strokeWidth={24.2266}
        strokeLinecap="round"
      />
      <path
        d="M200.176 119.729L180.507 131.085L246.373 245.168L277.399 253.482L200.176 119.729Z"
        fill="#C7D2FE"
      />
      <path
        d="M200.177 119.729L219.846 108.373L285.712 222.456L277.399 253.482L200.177 119.729Z"
        fill="#A5B4FC"
      />
      <path
        d="M184.941 114.538L203.299 103.938L181.344 65.9107C178.417 60.8412 171.935 59.1043 166.865 62.0312V62.0312C161.796 64.958 160.059 71.4403 162.986 76.5098L184.941 114.538Z"
        fill="#C7D2FE"
      />
      <rect
        width={72.6797}
        height={16.6558}
        rx={1.51416}
        transform="matrix(0.866025 -0.5 -0.5 -0.866025 168.706 137.898)"
        fill="#F9FAFB"
      />
      <ellipse
        cx={38.6111}
        cy={37.097}
        rx={38.6111}
        ry={37.097}
        transform="matrix(-1 0 0 1 312.436 32.3345)"
        fill="#6366F1"
      />
      <path
        d="M300.322 70.1885C300.322 72.1964 299.125 74.122 296.996 75.5418C294.866 76.9616 291.977 77.7593 288.966 77.7593C285.954 77.7593 283.065 76.9616 280.936 75.5418C278.806 74.122 277.609 72.1964 277.609 70.1885L288.966 70.1885L300.322 70.1885Z"
        fill="white"
      />
      <ellipse
        cx={6.05665}
        cy={6.81373}
        rx={6.05665}
        ry={6.81373}
        transform="matrix(-1 0 0 1 314.376 61.1035)"
        fill="#1F2937"
      />
      <ellipse
        cx={6.05665}
        cy={6.81373}
        rx={6.05665}
        ry={6.81373}
        transform="matrix(-1 0 0 1 279.124 61.1035)"
        fill="#1F2937"
      />
      <path
        d="M253.899 110.51C268.263 117.201 282.118 114.625 290.94 110.788C294.179 109.379 298.278 110.895 299.207 114.302L340.968 267.424C341.849 270.657 339.415 273.843 336.064 273.843H202.038C198.598 273.843 196.152 270.498 197.195 267.22L246.066 113.626C247.082 110.433 250.861 109.095 253.899 110.51Z"
        fill="#4338CA"
      />
      <path
        d="M284.752 114.709C284.752 114.709 301.836 183.97 307.135 270.937"
        stroke="#312E81"
        strokeWidth={3.02832}
        strokeLinecap="round"
      />
      <ellipse
        cx={4.54149}
        cy={5.20431}
        rx={4.54149}
        ry={5.20431}
        transform="matrix(-0.994137 0.108129 0.112124 0.993694 281.645 135.087)"
        fill="#312E81"
      />
      <ellipse
        cx={4.54149}
        cy={5.20431}
        rx={4.54149}
        ry={5.20431}
        transform="matrix(-0.994137 0.108129 0.112124 0.993694 285.526 166.138)"
        fill="#312E81"
      />
      <path
        d="M341.56 59.2098L211.085 70.6003C206.854 70.9696 205.188 65.2515 208.955 63.2906L221.757 56.627C226.356 54.233 228.667 49.0525 228.964 43.8759C229.729 30.5483 237.814 12.8004 266.368 8.90136C295.5 4.92325 307.897 22.4077 311.9 36.6284C313.309 41.6333 316.913 46.0305 321.992 47.1458L342.055 51.552C346.396 52.5053 345.988 58.8232 341.56 59.2098Z"
        fill="#A5B4FC"
      />
      <path
        d="M383.053 301.616L453.246 230.004C456.857 226.32 454.247 220.106 449.088 220.106H13.8593C8.70034 220.106 6.09018 226.32 9.70138 230.004L79.894 301.616H383.053Z"
        fill="#312E81"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M380.185 56.277C381.439 54.1044 384.217 53.36 386.39 54.6143C388.562 55.8687 389.307 58.6469 388.052 60.8195L285.926 237.708C286.16 238.174 286.35 238.67 286.49 239.193L292.755 262.573C296.32 275.877 293.82 290.075 285.926 301.361L198.893 301.361L217.21 271.071C227.097 254.722 242.924 242.83 261.379 237.885L276.983 233.704C277.272 233.626 277.562 233.566 277.852 233.523L380.185 56.277Z"
        fill="#C7D2FE"
      />
      <path
        d="M364.322 83.089C364.322 83.089 371.281 81.483 373.958 84.1597"
        stroke="#6366F1"
        strokeWidth={24.2266}
        strokeLinecap="round"
      />
      <path
        d="M307.071 201.071C261.464 223.389 192.5 174 241.5 128.5"
        stroke="#6366F1"
        strokeWidth={24.2266}
        strokeLinecap="round"
      />
      <path
        d="M150.068 282.209L163.592 282.209L164.818 282.209C169.046 282.209 171.164 277.099 168.177 274.107L158.172 264.087C156.109 262.022 153.31 260.861 150.391 260.861L150.068 260.861C144.173 260.861 139.394 265.64 139.394 271.535C139.394 277.43 144.173 282.209 150.068 282.209Z"
        fill="#FFFBEB"
      />
      <path
        d="M173.942 242.504L183.505 252.067L184.371 252.933C187.361 255.923 192.473 253.808 192.476 249.58L192.486 235.42C192.488 232.501 191.329 229.701 189.265 227.637L189.037 227.409C184.869 223.24 178.11 223.24 173.942 227.409C169.773 231.577 169.773 238.335 173.942 242.504Z"
        fill="#FFFBEB"
      />
      <path
        d="M334.92 263.409L325.357 272.972L324.49 273.838C321.501 276.828 323.616 281.94 327.844 281.943L342.003 281.953C344.923 281.955 347.723 280.796 349.787 278.732L350.015 278.504C354.184 274.335 354.184 267.577 350.015 263.409C345.847 259.24 339.088 259.24 334.92 263.409Z"
        fill="#FFFBEB"
      />
    </svg>
  );
};
export default RowingJules;
